"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapNavigationData = void 0;
var _net = require("../models/graphql-types/net");
const mapLinkType = linkType => {
  if (Object.values(_net.NavigationLinkType).includes(linkType)) {
    return linkType;
  }
  return _net.NavigationLinkType.None;
};
const mapType = type => {
  if (Object.values(_net.NavigationType).includes(type)) {
    return type;
  }
  return null;
};
const mapNavigationData = data => (data ?? []).map(item => ({
  children: mapNavigationData(item.children),
  linkType: mapLinkType(item.linkType),
  type: mapType(item.type),
  description: item.description ?? null,
  id: item.id ?? null,
  imageUrl: item.imageUrl ?? null,
  title: item.title ?? null,
  url: item.link?.relativeUrl ?? null
}));
exports.mapNavigationData = mapNavigationData;
